module.exports = __webpack_public_path__ + "img/curacao.485393fb.svg";